import controller from './kform-tab-attribut.controller';
import template from './kform-tab-attribut.html';

export default {
	template,
	controller,
	bindings: {
		disabled:   '<?ngDisabled',
		form:       '<',
		kid:        '<',
	},
	require: {
		kform:   '^^?kform',
	},
};
